module.exports = __webpack_public_path__ + "static/media/game.e0fbe759.svg";